var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      backgroundClass: "white",
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_eventType_from_editTitle")
        : _vm.$t("label_essweb_eventType_from_viewTitle"),
      delBtn: "",
      editBtn: !_vm.iSEdited,
      initData: _vm.eventTypeData,
      checkData: [
        "event_type_status",
        "event_type_name",
        "event_type_description",
        "event_type_abbr",
        "event_type_code",
        "table_name",
        "view_name",
        "container_name",
        "color_code",
        "remarks",
      ],
    },
    on: {
      edit: function ($event) {
        _vm.iSEdited = true
      },
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_eventType_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  {
                    staticClass: "white lighten-5",
                    attrs: { align: "center", justify: "start" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "4",
                          lg: "4",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "100",
                            readonly: !_vm.iSEdited,
                            bindData: _vm.eventTypeData.event_type_name,
                            label: _vm.$t(
                              "label_essweb_eventType_from_eventTypeNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.eventTypeData.event_type_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "4",
                          lg: "4",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "20",
                            readonly: !_vm.iSEdited,
                            bindData: _vm.eventTypeData.event_type_abbr,
                            label: _vm.$t(
                              "label_essweb_eventType_from_eventTypeAbbrLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.eventTypeData.event_type_abbr = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "4",
                          lg: "4",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          {
                            staticClass:
                              "mrc_text_require text--secondary pl-1 mt-1",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_eventType_from_tagColorLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("SelectColor", {
                          attrs: {
                            items: _vm.$Colors,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            height: 40,
                            appendIcon: _vm.iSEdited ? "arrow_drop_down" : "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.eventTypeData.color_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.eventTypeData, "color_code", $$v)
                            },
                            expression: "eventTypeData.color_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.eventTypeData.event_type_description,
                            maxlength: "500",
                            label: _vm.$t(
                              "label_essweb_eventType_from_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.eventTypeData.event_type_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            label: _vm.$t(
                              "label_essweb_eventType_from_eventTypeCodeLabel"
                            ),
                            readonly: !_vm.iSEdited,
                            maxlength: "100",
                            filled: _vm.iSEdited,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.eventTypeData.event_type_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.eventTypeData,
                                "event_type_code",
                                $$v
                              )
                            },
                            expression: "eventTypeData.event_type_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                          "offset-md": "0",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_eventType_from_tableNameLabel"
                                  )
                                )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.tables,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            filled: _vm.iSEdited,
                            disabled: true,
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            "single-line": "",
                            "menu-props": {
                              offsetY: true,
                              transition: "slide-y-transition",
                              rounded: true,
                              contentClass: "elevation-4",
                            },
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            readonly: !_vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_eventType_from_tableNameLabel"
                            ),
                            dense: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.view_fields
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-title text--primary",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              data.item.view_fields
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.eventTypeData.table_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.eventTypeData, "table_name", $$v)
                            },
                            expression: "eventTypeData.table_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_eventType_from_remarkLabel"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            filled: _vm.iSEdited,
                            "single-line": "",
                            readonly: !_vm.iSEdited,
                            dense: "",
                            counter: "500",
                            name: "input-7-4",
                          },
                          model: {
                            value: _vm.eventTypeData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.eventTypeData, "remarks", $$v)
                            },
                            expression: "eventTypeData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }